import TextField from "@/components/form/inputs/TextField.vue"
import TextArea from "@/components/form/inputs/TextArea.vue"
import SelectField from "@/components/form/inputs/SelectField.vue"
import RadioButton from "@/components/form/inputs/RadioButton.vue"
import CheckBox from "@/components/form/inputs/CheckBox.vue"
import DatePicker from "@/components/form/inputs/DatePicker.vue"
import Address from "@/components/form/inputs/Address.vue"
import FlinksiFrame from "@/components/form/inputs/FlinksiFrame.vue"
import SmsVerification from "@/components/form/inputs/SmsVerification.vue"
import IframeSmsVerification from "@/components/form/inputs/IframeSmsVerification.vue"
import MemberEnrollment from "@/components/form/inputs/MemberEnrollment.vue"

const COMPONENTS_PER_TYPE = {
    text: TextField,
    textarea: TextArea,
    select: SelectField,
    radio: RadioButton,
    checkbox: CheckBox,
    date: DatePicker,
    fulladdress: Address,
    flinks: FlinksiFrame,
    smsverification: SmsVerification,
    // iframe-only: stateless token endpoints (swapped in by iframe-derive.js)
    iframesmsverification: IframeSmsVerification,
    memberenrollment: MemberEnrollment,
}

export function getComponent(type) {
    return COMPONENTS_PER_TYPE[type] ?? TextField;
}

export function getComponents() {
    return Object.values(COMPONENTS_PER_TYPE);
}
